import { Typography } from 'antd';
import { useRefreshTimestamp } from '@wappsto/blanket';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { BaseType } from 'antd/es/typography/Base';

const FORMAT = 'MMMM DD YYYY, H:mm';
const DISPLAY = 'inline-block';

dayjs.extend(relativeTime);

interface TimestampProps {
  timestamp?: string;
  prefix?: string;
  display?: string;
  fromNow?: boolean;
  format?: string;
  style?: Record<string, any>;
  type?: BaseType;
  className?: string;
}

function Timestamp(
  {
    timestamp = '',
    prefix = '',
    display = DISPLAY,
    fromNow = false,
    format = FORMAT,
    style = undefined,
    type = 'secondary',
    className = '',
  }: TimestampProps,
) {
  const date = dayjs(timestamp || '', (dayjs as any).ISO_8601);
  let dateString = '';

  // update timestamp field
  useRefreshTimestamp(timestamp || '');

  if (!date.isValid()) {
    return '-';
  }

  if (fromNow) {
    dateString = date.fromNow();
  } else {
    dateString = date.format(format);
  }

  return (
    <Typography.Text type={type} style={{ display, ...style }} className={className}>
      {prefix + dateString}
    </Typography.Text>
  );
}

export default Timestamp;
